let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("7mIf9"), load("jXweD"), load("fliVL"), load("ieefZ")]).then(() => parcelRequire('3sora'));